export var ShareConfigType;
(function (ShareConfigType) {
    ShareConfigType["PublicRead"] = "publicRead";
    ShareConfigType["Private"] = "private";
    ShareConfigType["Inherit"] = "inherit";
    ShareConfigType["Parents"] = "parents";
    ShareConfigType["Children"] = "children";
    ShareConfigType["Family"] = "family";
})(ShareConfigType || (ShareConfigType = {}));
